import HomeIconInactive from "../images/icons/homeIconInactive.svg?react";
import HomeIconActive from "../images/icons/homeIconActive.svg?react";
import ExploreIconActive from "../images/icons/exploreIconActive.svg?react";
import ExploreIconInactive from "../images/icons/exploreIconInactive.svg?react";
import CategoryIconInactive from "../images/icons/categoryIcon.svg?react";
import CategoryIconActive from "../images/icons/categoryActiveIcon.svg?react";
import PlusIcon from "../images/icons/plusThink.svg?react";
import PlusThinkActive from "../images/icons/plusThinkActive.svg?react";
import BookmarkIconActive from "../images/icons/bookmarkIconActive.svg?react";
import BookmarkIconInactive from "@/common/images/icons/saved.svg?react";
import ProfileIconActive from "../images/icons/profileIconActive.svg?react";
import ProfileIconInactive from "../images/icons/profileIconInactive.svg?react";
import { useMemo } from "react";
import { routes } from "@/common/utils/routes";
import { TABS_LABELS, TABS_URLS } from "../helpers";

type IsTabActive = (tab: string) => string | boolean | null;

interface UseFooterMenuItemsParams {
  currentUserName: string | null;
  isTabActive: IsTabActive;
  onSendMetricAndCloseMenu: (
    tabName: TABS_URLS,
    label: TABS_LABELS,
    targetUrl: string,
  ) => void;
  onProfileClick: () => void;
  isProfileMenuOpen: boolean;
}

export const useFooterMenuItems = ({
  currentUserName,
  isTabActive,
  onSendMetricAndCloseMenu,
  onProfileClick,
  isProfileMenuOpen,
}: UseFooterMenuItemsParams) => {
  const isTabActiveFor = (tab: TABS_URLS): boolean =>
    !isProfileMenuOpen && !!isTabActive(tab);

  const menuItems = useMemo(() => ([
    {
      icon: isTabActiveFor(TABS_URLS.home) ? HomeIconActive : HomeIconInactive,
      link: routes.home(),
      title: TABS_LABELS.home,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.home, TABS_LABELS.home, routes.home()),
      isActive: isTabActiveFor(TABS_URLS.home)
    },
    {
      icon: isTabActiveFor(TABS_URLS.explore) ? ExploreIconActive : ExploreIconInactive,
      link: routes.explore(),
      title: TABS_LABELS.explore,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.explore, TABS_LABELS.explore, routes.explore()),
      isActive: isTabActiveFor(TABS_URLS.explore)
    },
    {
      icon: isTabActiveFor(TABS_URLS.add) ? PlusThinkActive : PlusIcon,
      link: routes.create(),
      title: TABS_LABELS.add,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.add, TABS_LABELS.add, routes.create()),
      isActive: isTabActiveFor(TABS_URLS.add)
    },
    ...(currentUserName ? [{
      icon: isTabActiveFor(TABS_URLS.saved) ? BookmarkIconActive : BookmarkIconInactive,
      link: routes.userCollections(currentUserName || ""),
      title: TABS_LABELS.saved,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.saved, TABS_LABELS.saved, routes.userCollections(currentUserName || "")),
      isActive: isTabActiveFor(TABS_URLS.saved)
    }] : [{
      icon: isTabActiveFor(TABS_URLS.categories) ? CategoryIconActive : CategoryIconInactive,
      link: routes.trendingTags(),
      title: TABS_LABELS.categories,
      onClick: () => onSendMetricAndCloseMenu(TABS_URLS.categories, TABS_LABELS.categories, routes.trendingTags()),
      isActive: isTabActiveFor(TABS_URLS.categories)
    }]),
    {
      icon: isTabActive(TABS_URLS.profile) || isProfileMenuOpen ? ProfileIconActive : ProfileIconInactive,
      title: currentUserName ? "Profile" : "Log in",
      onClick: onProfileClick,
      isActive: !!(isTabActive(TABS_URLS.profile) || isProfileMenuOpen)
    },
  ]), [currentUserName, isTabActive, onSendMetricAndCloseMenu]);

  return menuItems;
};

